import * as yup from 'yup'

const schema = {
  comment: yup.string().required('approvalDetail.commentRequiredStart'),
  sendPreNotice: yup.boolean(),
}

export const approvalDetailsSchema = yup.object().shape(schema)
